/**
 * The workspace toolbar's theme toggle, rendered THROUGH {@link ToolbarIconButton}
 * so it inherits the EXACT same size / hover / active / mobile-44px / styled-tooltip
 * treatment as every other toolbar control (the IDE1 fix: it used to be a separate
 * 30px borderless component with a 20px glyph and no tooltip, which broke toolbar
 * consistency — one item visibly different from its siblings).
 *
 * This is deliberately NOT the shared {@link import('./ThemeToggle.js').ThemeToggle}
 * used on the auth pages and global header: those surfaces don't load Workspace.css
 * (which sizes `.mol-toolbar-icon-btn`) and have their own design language, so they
 * keep the standalone toggle.
 *
 * @module
 */

import { useTheme, useTranslation } from '@molecule/app-react'

import { ToolbarIconButton } from './ToolbarIconButton.js'

/**
 * Renders the workspace toolbar's light/dark theme toggle as a
 * {@link ToolbarIconButton}, so it matches the surrounding toolbar buttons.
 * @returns The toolbar theme-toggle button.
 */
export function WorkspaceThemeToggle() {
  const { t } = useTranslation()
  const { mode, toggleTheme } = useTheme()

  return (
    <ToolbarIconButton
      icon={mode === 'dark' ? 'moon' : 'sun'}
      label={t('theme.toggle', undefined, { defaultValue: 'Toggle theme' })}
      molId="topbar-theme-toggle"
      onClick={toggleTheme}
    />
  )
}
